import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "filter-section" };
const _hoisted_2 = { class: "brg-input-section month-picker-activator-with-icon" };
const _hoisted_3 = { class: "brg-color-grey-600 text-subtitle-2" };
const _hoisted_4 = { key: 0 };
const _hoisted_5 = { class: "default-text-color" };
const _hoisted_6 = { class: "ml-3" };
const _hoisted_7 = { key: 1 };
const _hoisted_8 = { class: "default-text-color" };
const _hoisted_9 = { class: "ml-3" };
const _hoisted_10 = { class: "info-with-filter-tools-wrapper" };
const _hoisted_11 = {
    key: 0,
    class: "info-text"
};
const _hoisted_12 = { key: 0 };
const _hoisted_13 = { class: "body1-text" };
const _hoisted_14 = { class: "d-flex flex-column align-end" };
const _hoisted_15 = { class: "info-text" };
const _hoisted_16 = { class: "body1-text" };
const _hoisted_17 = { class: "info-text" };
const _hoisted_18 = { class: "body1-text" };
const _hoisted_19 = { class: "info-text grey--text text--darken-1" };
const _hoisted_20 = { class: "body1-text" };
import { computed, onBeforeMount, onUnmounted, ref, watch, } from 'vue';
import { useRoute, useRouter, } from 'vue-router';
import { i18n } from '@/locales';
import { setValidSelectedMonth } from '@/utils';
import { setDefaultSelectedMonthMaxDate } from '@/utils/time';
import { userPermission } from '@/constants';
import { getGlobalStore } from '@/lib/global-store';
import SubControllerTemplate from '@/templates/SubControllerTemplate.vue';
import { snackbarActionType } from '@/vuex-store/snackbar/actions';
import TaxInvoiceDialog from './TaxInvoiceDialog/index.vue';
const lc = 'views.hub_adjustment.';
const minMonth = '2023-11';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SubController',
    setup(__props) {
        const locale = {
            businessStatus: i18n.t(`${lc}business_status`),
            taxType: i18n.t(`${lc}tax_type`),
            infoNoRequestedTaxInvoice: i18n.t(`${lc}info_no_requested_tax_invoice`),
            infoAlertAdditionalTaxWithMonth: (month) => i18n
                .t(`${lc}info_alert_additional_tax_with_month`, {
                month,
            }),
            infoSubAlertAdditionalTax: i18n.t(`${lc}info_sub_alert_additional_tax`),
        };
        const route = useRoute();
        const router = useRouter();
        const vuexStore = getGlobalStore();
        const getterSelectedMonthComputed = computed({
            get: () => vuexStore.getters['hubAdjustment/hubMainReport/getterSelectedMonth'],
            set: () => { },
        });
        const getterSubscribeHubId = computed({
            get: () => vuexStore.getters['hubSelector/getterSubscribeHubId'],
            set: () => { },
        });
        const getterFormattedBusinessStatusType = computed({
            get() {
                return vuexStore.getters['hubAdjustment/hubMainReport/getterFormattedBusinessStatusType'];
            },
            set() { },
        });
        const getterFormattedTaxType = computed({
            get() {
                return vuexStore.getters['hubAdjustment/hubMainReport/getterFormattedTaxType'];
            },
            set() { },
        });
        const getterTaxInvoiceId = computed({
            get() {
                return vuexStore.getters['hubAdjustment/hubMainReport/getterTaxInvoiceId'];
            },
            set() { },
        });
        const isStatusVisible = computed({
            get() {
                return !!getterFormattedBusinessStatusType.value;
            },
            set() { },
        });
        const isTaxInvoiceBtnDisabled = computed({
            get() {
                return !getterTaxInvoiceId.value;
            },
            set() { },
        });
        const isInitialized = ref(false);
        watch(() => getterSelectedMonthComputed.value, async () => {
            if (!isInitialized.value || !getterSubscribeHubId.value) {
                return;
            }
            const { message } = await vuexStore.dispatch('hubAdjustment/hubMainReport/getHubMainReport');
            if (message) {
                vuexStore.dispatch(snackbarActionType.showError, {
                    message,
                });
            }
        }, {
            deep: true,
        });
        watch(() => getterSubscribeHubId.value, async (value) => {
            if (!isInitialized.value || !value) {
                return;
            }
            vuexStore.dispatch('app/setPageTitle');
            const { message } = await vuexStore.dispatch('hubAdjustment/hubMainReport/getHubMainReport');
            if (message) {
                vuexStore.dispatch(snackbarActionType.showError, {
                    message,
                });
            }
        });
        const setRouterParams = (selectedMonth) => {
            const newParams = {
                params: {
                    selectedMonth,
                },
            };
            router.replace(newParams).catch(() => { });
        };
        const selectedMonth = ref('');
        const selectedMonthForInfo = computed({
            get() {
                const monthStartIndex = 5;
                return Number(getterSelectedMonthComputed.value.substring(monthStartIndex));
            },
            set() { },
        });
        const maxMonth = ref('');
        const monthPickerDialog = ref(false);
        const initPage = () => {
            const LIMIT_TIME = 15;
            maxMonth.value = setDefaultSelectedMonthMaxDate(LIMIT_TIME);
            const { params } = route;
            const firstData = params.selectedMonth ?? [];
            const paramsSelectedMonth = firstData[0];
            selectedMonth.value = setValidSelectedMonth(paramsSelectedMonth, maxMonth.value, minMonth);
            vuexStore.dispatch('hubAdjustment/hubMainReport/setFilterOption', {
                selectedMonth: selectedMonth.value,
            });
            if (params.selectedMonth !== getterSelectedMonthComputed.value) {
                setRouterParams(getterSelectedMonthComputed.value);
            }
            isInitialized.value = true;
        };
        // const handleClickPickerCancel = () => {
        //   selectedMonth.value = getterSelectedMonthComputed.value;
        //   monthPickerDialog.value = false;
        // };
        const handleClickPickerSubmit = () => {
            vuexStore.dispatch('hubAdjustment/hubMainReport/setFilterOption', {
                selectedMonth: selectedMonth.value,
            });
            setRouterParams(getterSelectedMonthComputed.value);
            monthPickerDialog.value = false;
        };
        const handleClickTaxInvoiceBtn = () => {
            vuexStore.dispatch('hubAdjustment/taxInvoiceDialog/setDialogDetail', {
                hubId: getterSubscribeHubId.value,
                id: getterTaxInvoiceId.value,
                month: selectedMonthForInfo.value,
            });
        };
        /** 세금계산서 발행 가능 여부 (안내문구 노출여부를 위해 사용 중) */
        const isPostTaxInvoicePermitted = computed({
            get() {
                const isPermit = vuexStore.getters['user/getterUserPermission'](userPermission
                    .P_POST_TAX_INVOICE(), true);
                return isPermit;
            },
            set() { },
        });
        onBeforeMount(() => {
            initPage();
        });
        onUnmounted(() => {
            vuexStore.dispatch('hubAdjustment/hubMainReport/setFilterOption', {
                selectedMonth: '',
            });
            vuexStore.dispatch('hubAdjustment/hubMainReport/resetHubMainReport');
        });
        return (_ctx, _cache) => {
            const _component_vue_datepicker_action_row = _resolveComponent("vue-datepicker-action-row");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_vue_datepicker = _resolveComponent("vue-datepicker");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_icon = _resolveComponent("v-icon");
            return (_openBlock(), _createBlock(SubControllerTemplate, null, {
                toolsSlot: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", null, [
                            _createVNode(_component_vue_datepicker, {
                                modelValue: selectedMonth.value,
                                "onUpdate:modelValue": [
                                    _cache[0] || (_cache[0] = ($event) => ((selectedMonth).value = $event)),
                                    handleClickPickerSubmit
                                ],
                                "month-picker": "",
                                position: "left",
                                format: "yyyy-MM",
                                "model-type": "yyyy-MM",
                                "min-date": minMonth,
                                "max-date": maxMonth.value
                            }, {
                                "action-row": _withCtx((props) => [
                                    _createVNode(_component_vue_datepicker_action_row, _mergeProps(props, { "display-format": "yyyy-MM" }), null, 16 /* FULL_PROPS */)
                                ]),
                                "dp-input": _withCtx(() => [
                                    _createElementVNode("div", _hoisted_2, [
                                        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('common.select_period')), 1 /* TEXT */),
                                        _createVNode(_component_v_text_field, {
                                            value: getterSelectedMonthComputed.value,
                                            variant: "outlined",
                                            density: "compact",
                                            readonly: "",
                                            "hide-details": "",
                                            class: "mt-2",
                                            "bg-color": "white",
                                            "prepend-inner-icon": "mdi-calendar-month-outline"
                                        }, null, 8 /* PROPS */, ["value"])
                                    ])
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["modelValue", "max-date"])
                        ]),
                        _createCommentVNode(" 사업자등록번호 유효성 결과 "),
                        (isStatusVisible.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createVNode(_component_v_btn, {
                                    readonly: "",
                                    class: "brg-btn primary outlined size-l px-4 d-flex"
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_5, _toDisplayString(locale.businessStatus), 1 /* TEXT */),
                                        _createElementVNode("div", _hoisted_6, _toDisplayString(getterFormattedBusinessStatusType.value), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]))
                            : _createCommentVNode("v-if", true),
                        _createCommentVNode(" 과세유형 "),
                        (isStatusVisible.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                _createVNode(_component_v_btn, {
                                    readonly: "",
                                    class: "brg-btn primary outlined size-l px-4 d-flex"
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_8, _toDisplayString(locale.taxType), 1 /* TEXT */),
                                        _createElementVNode("div", _hoisted_9, _toDisplayString(getterFormattedTaxType.value), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]))
                            : _createCommentVNode("v-if", true),
                        _createCommentVNode(" 세금계산서 조회 버튼 "),
                        (isStatusVisible.value)
                            ? (_openBlock(), _createBlock(TaxInvoiceDialog, {
                                key: 2,
                                lc: lc,
                                disabled: isTaxInvoiceBtnDisabled.value,
                                onOnClickBtn: handleClickTaxInvoiceBtn
                            }, null, 8 /* PROPS */, ["disabled"]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                        _createCommentVNode(" 세금계산서 안내문 "),
                        (isStatusVisible.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createCommentVNode(" 조회 불가능 "),
                                (isTaxInvoiceBtnDisabled.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                        _createVNode(_component_v_icon, {
                                            start: "",
                                            size: "24"
                                        }, {
                                            default: _withCtx(() => _cache[1] || (_cache[1] = [
                                                _createTextVNode(" mdi-information-outline ")
                                            ])),
                                            _: 1 /* STABLE */,
                                            __: [1]
                                        }),
                                        _createElementVNode("span", _hoisted_13, _toDisplayString(locale.infoNoRequestedTaxInvoice), 1 /* TEXT */)
                                    ]))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createCommentVNode(" 조회 가능 "),
                                        _createElementVNode("div", _hoisted_14, [
                                            _createCommentVNode(" 기본 안내 "),
                                            _withDirectives(_createElementVNode("div", _hoisted_15, [
                                                _createVNode(_component_v_icon, {
                                                    start: "",
                                                    size: "24"
                                                }, {
                                                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                                                        _createTextVNode(" mdi-information-outline ")
                                                    ])),
                                                    _: 1 /* STABLE */,
                                                    __: [2]
                                                }),
                                                _createElementVNode("span", _hoisted_16, _toDisplayString(locale.infoAlertAdditionalTaxWithMonth(selectedMonthForInfo.value)), 1 /* TEXT */)
                                            ], 512 /* NEED_PATCH */), [
                                                [_vShow, isPostTaxInvoicePermitted.value]
                                            ]),
                                            _createCommentVNode(" 추가 안내문 "),
                                            _withDirectives(_createElementVNode("div", _hoisted_17, [
                                                _createVNode(_component_v_icon, {
                                                    start: "",
                                                    size: "24"
                                                }, {
                                                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                                                        _createTextVNode(" mdi-information-outline ")
                                                    ])),
                                                    _: 1 /* STABLE */,
                                                    __: [3]
                                                }),
                                                _createElementVNode("span", _hoisted_18, _toDisplayString(locale.infoSubAlertAdditionalTax), 1 /* TEXT */)
                                            ], 512 /* NEED_PATCH */), [
                                                [_vShow, isPostTaxInvoicePermitted.value]
                                            ])
                                        ])
                                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                            ]))
                            : _createCommentVNode("v-if", true),
                        _createCommentVNode(" 익월 1일 오후 3시 이후에 정산서를 확인하실 수 있습니다. "),
                        _createElementVNode("div", _hoisted_19, [
                            _createVNode(_component_v_icon, {
                                start: "",
                                size: "24"
                            }, {
                                default: _withCtx(() => _cache[4] || (_cache[4] = [
                                    _createTextVNode(" mdi-information-outline ")
                                ])),
                                _: 1 /* STABLE */,
                                __: [4]
                            }),
                            _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t(`${lc}report_available_date_information`)), 1 /* TEXT */)
                        ])
                    ])
                ]),
                _: 1 /* STABLE */
            }));
        };
    }
});
